export default __webpack_public_path__ + "static/media/PonguTransparent.13b04827.png";